<template>
  <div id="sngl-question">
    <ProgressBar v-if="this.$route.name !== 'end'" />
    <transition name="custom">
      <div class="question-wrap">
        <div class="question-content">

          <div class="question-details">

            <div class="question-statement" v-html="currentQuestion.question"></div>

            <div v-for="(answerObj, index) in currentQuestion.answers" :key="`ans-${index}`"
            :class="
              `${readyNext === 1? 'answered ' : ''}
              ${answerObj.chosen? 'chosen ' : ''}
              ${answerObj.points === 2 && readyNext === 1 ? 'success ' : ''}
              ${answerObj.points === 1 && readyNext === 1 ? 'warning ' : ''}
              ${answerObj.points === 0 && readyNext === 1 ? 'error ' : ''}
              obj-answer item-${index}`
            "
            @click="chooseAnswer(answerObj, index)"
            v-html="answerObj.txt"></div>

            <div :class="`recap ${readyNext ? 'show-errors': ''}`">
              <div class="recap-bloc" v-if="currentQuestion.recap">
                <div class="txt" v-html="currentQuestion.recap"></div>
              </div>
            </div>

            <div class="question-actions">
              <router-link id="next-qstn" @click.native="qstnBtn" class="next-question" v-if="readyNext" :to="`${this.nextStep}`" v-html="btnDesc() + this.btnArrow"></router-link>
            </div>

          </div> <!-- question-details -->
        </div> <!-- question-content -->
      </div> <!-- question-wrap -->
    </transition>
  </div> <!-- sngl-question -->
</template>

<script>
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/ProgressBar.vue'

export default {
  name: 'question',
  data () {
    return {
      activeQuestion: {},
      currentQuestion: {},
      readyNext: 0,
      userPoints: 0,
      totalScore: 0,
      countStep: 0,
      nextStep: 0,
      currentStep: Number(this.$route.params.question),
      btnArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="22.627" height="33.941" viewBox="0 0 22.627 33.941"><g data-name="Group 900" transform="translate(-1645.858 -831.858)"><g data-name="Rectangle 593" transform="translate(1651.515 831.858) rotate(45)" fill="none" stroke="#3baf29" stroke-width="2"><rect width="24" height="8" rx="4" stroke="none"/><rect x="1" y="1" width="22" height="6" rx="3" fill="none"/></g><g data-name="Rectangle 594" transform="translate(1645.858 860.142) rotate(-45)" fill="none" stroke="#3baf29" stroke-width="2"><rect width="24" height="8" rx="4" stroke="none"/><rect x="1" y="1" width="22" height="6" rx="3" fill="none"/></g></g></svg>'
    }
  },
  computed: {
    ...mapGetters([
      'contentGeneral'
    ])
  },
  components: { ProgressBar },
  methods: {
    getQuestions () {
      this.countStep = this.countStep + 1
      this.$store.dispatch({
        type: 'UPDATE_STEP',
        step: this.countStep
      })

      this.activeQuestion = {}
      const step = Number(this.$route.params.question)
      this.nextStep = '/q/' + (step + 1)

      if (step === this.$store.state.qa.length) {
        this.nextStep = '/end/'
      }

      this.currentQuestion = this.$store.state.qa[step - 1]

      // resets answers if replay
      this.currentQuestion.answers.forEach((qanwser, i) => {
        qanwser.chosen = false
      })
    },
    verifyAnswer () {
      this.currentQuestion.answers = Object.values(this.currentQuestion.answers).filter(obj => {
        obj.success = obj.points
        if (obj.chosen) {
          this.userPoints = obj.points
          this.$store.dispatch({
            type: 'UPDATE_SCORE',
            score: this.userPoints
          })
        }
        return obj
      })

      this.totalScore = this.totalScore + 1
      this.$store.dispatch({
        type: 'UPDATE_TOTAL',
        total: this.totalScore
      })

      // allow next step
      this.readyNext = 1
    },
    chooseAnswer (answer, index) {
      const intIndex = Number(index)
      answer.chosen = !answer.chosen
      this.currentQuestion.answers[intIndex] = answer

      // update v loop
      this.currentQuestion.answers.push()

      this.verifyAnswer()
    },
    chooseAnswerReinit (answer, index) {
      const intIndex = Number(index)
      answer.chosen = false
      this.currentQuestion.answers[intIndex] = answer

      // update v loop
      this.currentQuestion.answers.push()
    },
    btnDesc: function () {
      return (Number(this.$route.params.question) === this.$store.state.qa.length ? this.contentGeneral.btn_finish : this.contentGeneral.btn_next)
    },
    qstnBtn () {
      document.getElementById('sngl-question').classList.remove('load')
    }
  },
  mounted () {
    this.getQuestions()
  },
  watch: {
    $route () {
      document.getElementById('sngl-question').classList.remove('custom-enter-qstn', 'load')
      document.getElementById('sngl-question').classList.add('custom-enter-qstn')
      setTimeout(function () {
        document.getElementById('sngl-question').classList.add('load')
      }, 1)
      this.getQuestions()
      this.readyNext = 0
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/_variables';
@import '@/assets/_mixin';

#app {
  display: flex;
  align-items: center;
  #sngl-question {
    width: 100%;

    .question-wrap {
      position: relative;
      z-index: 1;
      /*************************************************************************
      QUESTION CONTENT
      *************************************************************************/
      .question-content {
        align-items: flex-start;
        display: flex;
        flex-wrap: wrap;
        /***********************************************************************
        QUESTION DETAILS
        ***********************************************************************/
        .question-details {
          .question-statement {
            max-width: 700px;
            font: {
              family: $font_fam;
              size: $font_sz*1.5;
              weight: $font_b;
            }
            letter-spacing: 1;
            margin-bottom: $pad;
            padding-top: $font_sz*.5;
            position: relative;

            // tablet landscape
            @media (max-width: 1200px) and (min-width: 600px),
            // mobile
             (max-width: $sml){
              font: {
                size: $font_sz*1.5;
              }
            }
            @media (max-width: $sml){
              font: {
                size: $font_sz*1.125;
              }
            }
            span {
              display: block;
              font-size: 0.625em;
              font-weight: $font_n;
              margin-bottom: $pad*0.5;
            }
          }
          .obj-answer {
            position: relative;
            padding: $pad;
            padding-left: $pad*3.5;
            margin-bottom: $font_sz*1.5;
            border: solid 2px $grey;
            border-radius: 35px;
            font: {
              family: $font_fam;
              size: $font_sz;
              weight: $font_l;
            }
            cursor: pointer;
            transition: all 0.2s ease-in-out;
            &:hover {
              &:after {
                background-color: $aqua;
              }
            }
            @media (max-width: $sml){
              padding-left: $pad*2.5;
            }
            &.answered {
              background-color: transparent;
              opacity: 0.5;
              &.chosen { opacity: 1 }
              &:after {
                border-color: $grey;
              }
            }
            &.success {
              border: solid 2px $green;
              &.chosen:after {
                border-color: $green;
                background: $green;
              }
            }
            &.warning {
              border: solid 2px $yellow;
              &.chosen:after {
                border-color: $yellow;
                background: $yellow;
              }
            }
            &.error {
              border: solid 2px $red;
              &.chosen:after {
                border-color: $red;
                background: $red;
              }
            }
            &.answered {
              pointer-events: none;
            }
            &:after {
              background: transparent;
              content: '';
              left: $pad*1.5;
              position: absolute;
              height: $font_sz; width: $font_sz;
              border: 2px solid $aqua;
              border-radius: 100%;
              top: 50%;
              margin-top: -10px;
              transition: all 0.2s ease-in-out;
              @media(max-width: $sml){
                height: $font_sz*0.75; width: $font_sz*0.75;
                left: $pad*0.75;
                margin-top: -8px;
              }
            }
          } // obj-answer
        } // question-details
      } // question-content

      /*************************************************************************
      ANSWER RECAP
      *************************************************************************/
      .recap {
        max-height: 0; overflow: hidden;  padding: 0; margin-bottom: 0;
        position: relative;
        &:after {
          opacity: 0;
          position: absolute;
          content: '';
          transition: opacity 0.25s 0.1s ease-in;
        }
        &.show-errors {
          max-height: 999px;
          overflow: hidden;
          margin-bottom: $pad*1.5;
          transition: margin-bottom 0.2s ease-in, max-height 0.75s ease-in, padding 0.1s ease-in;
          padding-left: 24px;
          &:before {
            position: absolute;
            content: '';
            height: 100%;
            background: $aqua;
            width: 8px;
            left: -1px;  top: 0;
            z-index: 1;
          }
        .recap-bloc {
          opacity: 1;
          transition: opacity 0.15s 0.1s ease-in;
        }
          overflow: visible;
        }
        .recap-bloc {
          opacity: 0;
          display: flex;
          align-items: center;
          margin-bottom: $pad*0.75;
          .txt {
            font: {
              size: $font_sz;
              weight: $font_l;
            }
            line-height: $font_sz*1.25;
            a {
              color: inherit;
            }
            @media (max-width: $sml){
              font: {
                size: $font_sz*0.9;
              }
            }
          }
        } // recap-bloc
      } // recap
      /*************************************************************************
      ACTIONS
      *************************************************************************/
      .question-actions {
        display: flex;
        margin-top: $pad*4;
        padding-top: $pad*1.5;
        border-top: solid 2px $grey;
        .submit,
        .next-question {
          @include btn();
          margin-left: auto;
          cursor: pointer;
        }
      }
    } // question-wrap
    /***************************************************************************
    IMAGE OF THE CATEGORY
    ***************************************************************************/
    .question-image {
      @include img(1,0);
      z-index: 0;
    }

  } // #sngl-question
} // #app

/*******************************************************************************
TRANSITION PAGE
*******************************************************************************/

.custom-enter-qstn.load {
  transition-property: opacity;
}

.custom-enter-qstn {
  @include transitionStyle(0,-120%,-120deg,-20%);
}

.custom-enter-qstn.load {
  @include transitionStyle(1,0%,0deg,0%);
  @include transtionQuestion();
} // custom-enter-qstn load

</style>
